// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media (min-width:599px)and (max-width:790px){.review-card{margin-left:.75rem;margin-right:.75rem}}.review-card__content-wrapper{min-height:56px}@media only screen and (max-width:770px){.review-card__content-wrapper{min-height:56px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
